import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
	selector: "app-customer-logo",
	standalone: true,
	template: `{{ letter() }}`,
	styleUrls: ["./customer-logo.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerLogoComponent {
	name = input<string | null | undefined>("");
	letter = computed(() => (this.name() ?? "").trim().charAt(0).toUpperCase());
}
